import { jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme } from '@mui/material';
export const CalendarMoreButton = ({ count, onClick, sx = {} }) => {
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            px: 1,
            py: 0.5,
            cursor: 'pointer',
            ...theme.typography.caption,
            color: theme.palette.text.primary,
            textAlign: 'left',
            fontWeight: 400,
            textDecoration: 'underline',
            ...sx
        }, onClick: onClick, children: ["+", count, " more"] }));
};
